/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { Box, PageWithNavigation, Title } from '../../components';
import './index.css';
// import CancelModal from './CancelModal';

const ns = 'settings';

export default () => {
  const { t } = useTranslation();
  const history = useHistory();

  const { language } = useSelector((state: any) => state.user);

  return (
    <div className={cn(ns)}>
      <Helmet>
        <title>{t('settings.sectionTitle')}</title>
      </Helmet>
      <PageWithNavigation showStores={false}>
        <Title>{t('settings.title')}</Title>
        <Box className={`${ns}__box`}>
          <div className="container">
            <div className="col">
              <div
                className="btn btn-setting"
                onClick={() => {
                  history.push(`/${language}/risk-rules`);
                }}
              >
                Manage risk rules
              </div>
            </div>
          </div>
        </Box>
      </PageWithNavigation>
    </div>
  );
};
